import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ToolbarImageEditIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        fill="none"
        viewBox="0 0 32 32"
        className="Icon toolbar-image-edit"
        {...props}
    >
        <rect width={32} height={32} fill="#1B2536" rx={4} />
        <path
            className="decoration"
            fill="none"
            stroke="#48505E"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="m21.49 12.95-2.44-2.44m-8.027 12.907 12.394-12.394c.322-.322.483-.483.543-.668a.8.8 0 0 0 0-.503c-.06-.186-.221-.347-.543-.669l-.6-.6c-.322-.322-.483-.483-.669-.543a.8.8 0 0 0-.503 0c-.185.06-.346.221-.668.543L8.583 20.977c-.322.322-.483.483-.543.668a.8.8 0 0 0 0 .503c.06.186.221.347.543.669l.6.6c.322.322.483.483.669.543.163.053.34.053.502 0 .186-.06.347-.221.67-.543M10.916 8.07l-.496.992c-.168.336-.252.504-.364.65q-.15.194-.344.344c-.146.112-.314.196-.65.364l-.992.496.992.497c.336.168.504.252.65.364q.194.15.344.344c.112.146.196.314.364.65l.496.992.497-.992c.168-.336.252-.504.364-.65q.15-.195.344-.344c.146-.112.314-.196.65-.364l.992-.497-.992-.496c-.336-.168-.504-.252-.65-.364q-.194-.15-.344-.344c-.112-.146-.196-.314-.364-.65zM21.49 18.643l-.354.71c-.12.24-.18.36-.26.463a1.4 1.4 0 0 1-.247.246c-.103.08-.223.14-.463.26l-.71.355.71.354c.24.12.36.18.463.26q.14.107.247.246c.08.104.14.224.26.464l.354.71.355-.71c.12-.24.18-.36.26-.464q.106-.139.246-.246c.104-.08.224-.14.464-.26l.708-.354-.708-.355c-.24-.12-.36-.18-.464-.26a1.4 1.4 0 0 1-.246-.246c-.08-.104-.14-.224-.26-.464z"
        />
    </svg>
);
const Memo = memo(ToolbarImageEditIcon);
export default Memo;
